import React, {Component} from 'react';
import { Flex, Link, Button } from "../../components";
import styled from 'styled-components';
//import { Redirect } from 'react-router-dom';
import ChartistGraph from 'react-chartist';
import Chartist from 'chartist';
import 'chartist-plugin-axistitle';
import 'chartist/dist/chartist.min.css'
import 'chartist-plugin-pointlabels';

// 959292c9
// aca9a9b0
let TopicBar = styled.div`
  border: 1px transparent black;
  border-radius: 5px;
  padding: 0.05em;
  display: flex;
  width: 90%;
  margin: auto;
  flex-direction: row;
  margin-bottom: 8px; 
  background: linear-gradient(to right, ${({ colour }) => colour} ${({ colorWidth }) => colorWidth}%, #aca9a9b0 ${({ greyColorWidth }) => greyColorWidth}%);
`

const TimeAnalysis = styled.div`
  margin: 10px;
  overflow: auto;
  background-color: white;
  -webkit-overflow-scrolling: touch;
`
const TimeAnalysisHeading = styled.div`
  position: absolute;
  width:95%;
  overflow-x:hidden;
  overflow-y: scroll;
`
const Heading = styled.h4`
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: black;
`
const SecondaryHeading = styled.p`
  text-align: center;
  font-size: 14px;
  color: #888787;
  margin-bottom: 20px;
  font-weight: 500;
`
// p style={{ color: '#827e7e', fontSize: '14px', marginBottom: '25px', textAlign: 'center'}}

class PracticeTestAnalysis extends Component {
  componentDidMount = () => {
    let answers = this.props.answers;
    let questions = this.props.questions
    let questionsLength = questions.length;
    let questArray = [];
    for (let i = 1; i <= questionsLength; i++) {
      questArray.push( i)
    }
    let timeArray = [];
    let answersForTime = answers || questions
    for (let i = 0; i < questionsLength; i++) {
      let timeTaken = 0
      let timeTakenArray
      if (!Array.isArray(answersForTime[i]['timetaken'])) {
        timeTakenArray = JSON.parse(answersForTime[i]['timetaken'])
      } else {
        timeTakenArray = answersForTime[i]['timetaken'];
      }
      timeTakenArray.map((item) => {
        timeTaken += +item[2]
      })

      timeArray.push(timeTaken)
      // timeArray.push({'y':timeTaken, 'x': 'Q' + i})
    }
    // timeArray[2] = 20
    let difference = (Math.max(...timeArray).toFixed(0)/10).toFixed(0)

    let data = {
      series: [timeArray],
      labels: questArray
    }
    console.log(data)
   
    let chart = new Chartist.Line('#ct-chart', data, {
      fullWidth: true,
      height: 250,
      chartPadding: {
        right: 20,
        left: -40
      }, plugins: [
        Chartist.plugins.ctPointLabels({
          textAnchor: 'right',
          fontSize: 8,
          labelInterpolationFnc: v=>v?v:0,
          labelOffset: {
            x: 0,
            y: -8
          }
        }),
        Chartist.plugins.ctAxisTitle({
          axisX: {
            axisTitle: 'Questions',
            axisClass: 'ct-axis-title',
            offset: {
              x: 0,
              y: 45
            },
            textAnchor: 'middle'
          },
          axisY: {
            axisTitle: 'Time (sec)',
            axisClass: 'ct-axis-title',
            offset: {
              x: 0,
              y: 15
            },
            textAnchor: 'middle',
            flipTitle: true
          }
        })
      ],
      axisX: {
        axisTitle: "Questions",
        gridThickness: 1,
        tickLength: 20,
        // scaleMinSpace: difference,
        offset: 45,
        // scaleMinSpace: 10,

        low: 0
      },
      axisY: {
        offset: 105,
        low: 0,
        // scaleMinSpace: difference,
        high: Math.max(...timeArray),

        // high: 10,
      }
    });
    chart.on('draw', function (data) {
      if (data.type === 'grid' && data.index !== 0) {
        data.element.remove();
      }
      if(data.type === 'point') {
        let is_correct = answers ? (answers[data.index].is_answer === 1 ? true : false) : (questions[data.index].correctly_answered === 1 ? true : false)
        let color = is_correct ? 'green' : 'red'
        data.element.attr({
          style: `stroke: ${color}`
        })
      }
    });


  }
  render () {
    // let colours = ['#45eeac', '#f65757f2', '#51a3e8', '#f45589', '#e4734e', '#95ea47', '#f8b840', '#28eaea', '#ea8ece', '#9585f6b5', '#7bf1f6', '#ec66a4', '#43ec67', '#1734fe9e', '#d1fe179e']
    let coloursDark = ['#16724e', '#c52f2ff2', '#0a73cb', '#e22764', '#fa5721', '#59a216', '#ae760e', '#08d1d1', '#d50997', '#3215e2b5', '#15777b', '#ec66a4', '#43ec67', '#1734fe9e', '#d1fe179e']
    let response = this.props.response;
    console.log(response)
    let chartWidth = response.total_questions_count <= 10 ? '100%' : response.total_questions_count <= 15 ? '120%' : '150%';
    return (
      <div>
        <TimeAnalysis style={{WebkitOverflowScrolling: 'touch'}}>
          <TimeAnalysisHeading>
            <Heading>TIME ANALYSIS </Heading>
            <SecondaryHeading>Check your time utilization pattern</SecondaryHeading>
          </TimeAnalysisHeading>
          <div className='chartDiv' style={{WebkitOverflowScrolling: 'auto'}}>
            <div id='ct-chart'></div>
          </div>
        </TimeAnalysis> 
        <div className='topicWiseAnalysis' style={{WebkitOverflowScrolling: 'auto'}}>
          <Heading>TOPIC WISE ANALYSIS</Heading>
          <SecondaryHeading>How you're performing in each category</SecondaryHeading>
          {response.summary.map(
            ({ name, correct, total_questions_count }, i) => {
              let colour = coloursDark[i]
              let percentage = parseFloat((correct / total_questions_count) * 100).toFixed(0);
              return <TopicBar colour={colour} key={i} style={{ }} colorWidth= {percentage} greyColorWidth={0} >
                  <p className='topicName'>{name}</p>
                  <p className='topicPercentage'>
                    {percentage}%
                  </p>
              </TopicBar>
            }
          )}
        </div>
        <style jsx='true' scoped>{`
            .topicWiseAnalysis{
              overflow: hidden auto;
              width: 100%;
              position: absolute;
              border-radius: 5px;
              padding: 10px;
              margin-bottom: 40px;
              -webkit-overflow-scrolling: auto;
            }
        
            .chartDiv{
              padding: 10px;
              position: relative;
              margin-top: 70px;
              overflow: auto;
              -webkit-overflow-scrolling: auto;
              width: ${chartWidth};
              height: 100%;
              white-space: nowrap;
              border-radius: 5px;
              overflow-x: auto;
            }

            .topicName{
              margin: 0.5em 0.8em;
              font-weight: 500;
              font-size: 12px;
              color: white;
              padding-right: 10px;
              width: 85%;
            }
            .topicPercentage{
              margin: 0.5em 0.6em;
              font-weight: 500;
              font-size: 12px;
              color: white;
              width: 15%;
            }
            #ct-chart{
            // background-color: black;
            font-family: sans-serif;
            stroke-dasharray: none;
            }
            #ct-chart .ct-grid {
              stroke-dasharray: none;
            }
            .ct-series-a .ct-line {
              /* Set the colour of this series line */
              stroke: #00000066;
              /* Control the thikness of your lines */
              stroke-width: 1px;
            }
            .ct-series-a .ct-point {
              /* Colour of your points */
              stroke: green;
              /* Size of your points */
              stroke-width: 5px;
            }
            .ct-grid {
              stroke: rgba(23, 2, 2, 0.94);
              stroke-width: 1.5px;
            }
            .ct-label {
              font-size: 10px;
              text-align: center;
            }

            .ct-chart .ct-label.ct-horizontal.ct-end {
              position: relative;
              justify-content: left;
              white-space:nowrap;
            }
            .ct-axis-title {
              //  color: #FFFFFF !important;
                font-family: sans-serif;
                // font-weight: 200; 
              }
          `}

        </style>
          
      </div>

    )
  }
}

export default PracticeTestAnalysis;